"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressPortfolio = getAddressPortfolio;
const client_1 = require("@apollo/client");
const client_js_1 = require("../client.js");
const userPortfolio_js_1 = require("../queries/userPortfolio.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const GET_USER_PORTFOLIO = (0, client_1.gql) `
  ${userPortfolio_js_1.alphalendUserPortfolioQuery}
`;
async function getAddressPortfolio(address, clientUrl) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const positionCapResponse = await suiClient.getOwnedObjects({
        owner: address,
        limit: 1,
        filter: {
            StructType: "0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::position::PositionCap",
        },
    });
    const positionCapId = positionCapResponse.data[0].data?.objectId;
    const client = (0, client_js_1.getClient)(clientUrl);
    const { data, } = await client.query({
        query: GET_USER_PORTFOLIO,
        variables: { positionCapId },
        fetchPolicy: "no-cache",
    });
    return data.userPortfolio;
}
//# sourceMappingURL=getAddressPortfolio.js.map